import React, { useState } from "react";
import { notify } from "../../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../../Interface/CtaButton";

function RenameCategorieModal({
  open,
  setOpen,
  categorieName,
  produitId,
  categorieId,
  loading,
  onSubmitAction
}) {
  const [categorieNewName, setCategorieNewName] = useState("");
  const [nameError, setNameError] = useState(false);

  const handleModalClosure = () => {
    setCategorieNewName("");
    setNameError(false);
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    const { type, message, details } = await onSubmitAction({
      categorieNewName,
      categorieId,
      produitId
    });

    if (type === "success") {
      notify("success", message);
      handleModalClosure();
    } else {
      notify("error", message);
    }
  };

  const handleCategorieSubmit = e => {
    if (e.key === "Enter") {
      if (setCategorieNewName.length > 0) handleModalSubmission();
      else setNameError(true);
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>
            Renommer la catégorie <strong>{categorieName}</strong>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>Nom de la catégorie</label>
          <input
            name="produit"
            type="text"
            className={`form-control ${nameError ? "has-error" : ""}`}
            onChange={({ target }) => setCategorieNewName(target.value)}
            onKeyUp={handleCategorieSubmit}
            value={categorieNewName}
          />
          <span className={`invalid-feedback ${nameError ? "show" : ""}`}>
            La catégorie doit avoir un nom valide
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton
            action={handleCategorieSubmit}
            text="Renommer"
            busy={loading}
          />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default RenameCategorieModal;
